import React from "react";
import SelectInput from "../../../../components/form/SelectInput";
import TextInput from "../../../../components/form/TextInput";
import { useFormProfileOptions } from "../../../../constants/form-profile";

import { useTranslation } from "react-i18next";

const AdditionalContactCard = ({
  contact,
  index,
  additionalContactSetter,
  additionalContacts,
}) => {
  const {
  RELATIONSHIP_OPTIONS_FIRST_PERSON,
  RELATIONSHIP_OPTIONS_SECOND_PERSON,
} = useFormProfileOptions();
  const { t, i18n } = useTranslation('editLoan');
  function handleFirstNameChange(e) {
    additionalContactSetter(
      additionalContacts.map((c) =>
        c.contact_id === contact.contact_id
          ? { ...c, first_name: e?.target?.value }
          : c
      )
    );
  }

  function handleLastNameChange(e) {
    additionalContactSetter(
      additionalContacts.map((c) =>
        c.contact_id === contact.contact_id
          ? { ...c, last_name: e?.target?.value }
          : c
      )
    );
  }

  function handlePhoneChange(e) {
    additionalContactSetter(
      additionalContacts.map((c) =>
        c.contact_id === contact.contact_id
          ? { ...c, phone: e?.target?.value }
          : c
      )
    );
  }

  function handleRelationshipChange(e) {
    additionalContactSetter(
      additionalContacts.map((c) =>
        c.contact_id === contact.contact_id
          ? { ...c, relation: e?.target?.value }
          : c
      )
    );
  }

  return (
    <div
      key={contact.contact_id}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        backgroundColor: "white",
        boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
        marginLeft: "20px",
        marginRight: "20px",
        padding: "20px",
        borderRadius: "10px",
      }}
    >
      <p style={{ fontSize: "16px", fontWeight: "bold" }}>
        {t('person')} {index + 1}
      </p>
      <TextInput
        style={{ display: "flex", flexDirection: "column" }}
        isFormik={false}
        label={t('name')}
        value={contact.first_name}
        onChange={handleFirstNameChange}
        placeholder={t('name')}
        required
      />
      <TextInput
        style={{ display: "flex", flexDirection: "column" }}
        label={t('surname')}
        isFormik={false}
        value={contact.last_name}
        onChange={handleLastNameChange}
        placeholder={t('surname')}
        required
      />
      <TextInput
        style={{ display: "flex", flexDirection: "column" }}
        label={t('tel')}
        isFormik={false}
        value={contact.phone}
        onChange={handlePhoneChange}
        placeholder={t('tel')}
        required
      />
      <SelectInput
        style={{ display: "flex", flexDirection: "column" }}
        isFormik={false}
        label={t('relation')}
        value={contact.relation}
        onChange={handleRelationshipChange}
        placeholder={t('selectRelation')}
        options={
          index === 0
            ? RELATIONSHIP_OPTIONS_FIRST_PERSON
            : RELATIONSHIP_OPTIONS_SECOND_PERSON
        }
        required
      />
      {contact.internal_notes && (
        <p style={{ fontSize: "14px", color: "red" }}>
          {contact.internal_notes}
        </p>
      )}
    </div>
  );
};

export default AdditionalContactCard;
